import React, {FC} from 'react'

type AppliedFee = {
  scope?: 'category' | 'practitioner' | 'listing' | null
  type?: 'flat_fee' | 'percentage' | null
  value?: number
  subtotalCents?: number
  feeCents?: number
  totalCents?: number
}

type Props = {
  appliedFee?: AppliedFee | null
}

// Surfaces the fee-rule audit trail snapshot captured on every booking
// (Booking.appliedFee) - which rule applied, its type/value, and the fee
// actually charged - rather than only living invisibly in the database.
// A booking made before the fee-rule system existed (or one that matched no
// rule) has no appliedFee/feeCents, so those show as "No fee applied"
// instead of a misleading $0.00.
const AppliedFeeCell: FC<Props> = ({appliedFee}) => {
  if (!appliedFee || appliedFee.feeCents == null) {
    return <span className='text-muted fs-7'>No fee applied</span>
  }

  const feeAmount = (appliedFee.feeCents / 100).toFixed(2)
  const subtotalAmount =
    appliedFee.subtotalCents != null ? (appliedFee.subtotalCents / 100).toFixed(2) : null

  const ruleLabel =
    appliedFee.type === 'percentage'
      ? `${appliedFee.value}%`
      : appliedFee.type === 'flat_fee'
      ? `${appliedFee.value} flat`
      : null

  return (
    <div>
      <div className='fw-bolder'>{feeAmount}</div>
      <div className='text-muted fs-8'>
        {ruleLabel}
        {ruleLabel && appliedFee.scope ? ' · ' : ''}
        {appliedFee.scope || ''}
        {subtotalAmount ? ` (on ${subtotalAmount})` : ''}
      </div>
    </div>
  )
}

export default AppliedFeeCell
